import "./BottomBarDeviceReadinessRecording.css";
import RecordInputButton from "../../../Shared/Components/RecordInputButton/RecordInputButton";
import { startRecording } from "../../../NewConstants/DeviceReadinessRecordConstant";

const BottomBarDeviceReadinessRecording = ({
  selectedLanguage
}) => {

  return (
    <div className="bottomBarDivRecord py-4 px-5 h-1/4 rounded-tl-3xl rounded-tr-3xl">
      <p className="flex items-center justify-center gap-3 pb-10 text-lg">{startRecording[selectedLanguage]}</p>
      <div className="flex items-center justify-center gap-3">
        
        <RecordInputButton
          largeIcon={true}
          selectedLanguageCode={selectedLanguage}
        />
      </div>
    </div>
  );
};

export default BottomBarDeviceReadinessRecording;
